import { CLIENT_ID, PASSWORDS_API_PREFIX } from '../consts';
import { GET, POST, PUT } from '../utils/request';

export function getResetOptions(email) {
  return GET(
    `${PASSWORDS_API_PREFIX}/restaurateurs/reset_options`,
    { email },
    {
      headers: {
        'client-id': CLIENT_ID,
      },
      noNeedLogin: true,
      parseAsJSONApi: true,
    }
  );
}

export function sendVerifyCode({ email, means }) {
  return POST(
    `${PASSWORDS_API_PREFIX}/restaurateurs/reset`,
    { email, means },
    {
      headers: {
        'client-id': CLIENT_ID,
      },
      noNeedLogin: true,
    }
  );
}

export function verifyEmailCode({ email, code }) {
  return POST(
    `${PASSWORDS_API_PREFIX}/restaurateurs/verify`,
    { email, code },
    {
      headers: {
        'client-id': CLIENT_ID,
      },
      silence: true,
      noNeedLogin: true,
    }
  );
}

export function resetPasswordByEmail({ email, password, password_confirmation, code }) {
  return PUT(
    `${PASSWORDS_API_PREFIX}/restaurateurs`,
    {
      email,
      password,
      password_confirmation,
      code,
    },
    {
      headers: {
        'client-id': CLIENT_ID,
      },
      noNeedLogin: true,
    }
  );
}
